import { render, staticRenderFns } from "./set-pass.vue?vue&type=template&id=db10ea94"
import script from "./set-pass.vue?vue&type=script&lang=js"
export * from "./set-pass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports